import './frame-busting';
import './public-path';
// manually import some corejs modules that uncompiled node modules require...
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.object.assign';
// IE CustomEvent polyfill
import './polyfills/custom-event';
// window.fetch polyfill
import 'whatwg-fetch';
import 'what-input';
import Vue from 'vue';
import App from './App.vue';
import router from './views/router';
import Icon from './components/content/Icon';
import VueAnalytics from 'vue-analytics';
import { isPrerender } from 'src/utilities';
import { disableTransitions } from './disable-transitions';

Vue.config.productionTip = false;

Vue.filter('usd', value => {
	return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
});

Vue.filter('number', value => {
	return value.toLocaleString('en-US');
});

if (process.env.NODE_ENV === 'development') {
	const error = console.error;
	let timer;
	console.error = function () {
		error.apply(this, arguments);
		clearTimeout(timer);
		// timer = setTimeout(() => window.alert('There was a console error. Please fix it.'), 500);
	};
}

if (!isPrerender())
	Vue.use(VueAnalytics, {
		id: process.env.GOOGLE_ANALYTICS_ID || 'UA-45624012-4',
		router
	});
else
	disableTransitions();

// add global $amp property to all components
Object.defineProperty(Vue.prototype, '$amp', { writable: false, value: process.env.AMP });

Vue.component('icon', Icon);

function attrsForPrerender() {
	return isPrerender() ? { attrs: { 'data-server-rendered': 'true' } } : {};
}

document.addEventListener('DOMContentLoaded', function () {
	const app = new Vue({
		router,
		render: h => h(App, attrsForPrerender())
	});
	router.onReady(() => {
		let dispatchRenderEvent = true;
		document.addEventListener('defer-render-event', () => {
			dispatchRenderEvent = false;
		});

		app.$mount('#app', true);

		if (isPrerender()) {
			Vue.nextTick(() => {
				if (dispatchRenderEvent) {
					document.dispatchEvent(new Event('render-event'));
				}
			});
		}
	});
});

// break page state caching for firefox and safari
window.addEventListener('unload', function () { });

if (module.hot) module.hot.accept();